export default __webpack_public_path__ + "static/media/Oct-Blog-image.5af4740e.jpg";